import React, {useState} from 'react';

import {fullPath, redirectForDownload} from 'BenchlingUtil';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import TextField from 'ui-library/inputs/TextField';
import Modal from 'ui-library/modals/Modal';
import {InputChangeEvent} from 'util/Types';

interface Props {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function SwaggerRedirectModal(props: Props): JSX.Element {
  const [tenantSubdomain, setTenantSubdomain] = useState('');

  function handleSubmit(): void {
    const url = `https://${tenantSubdomain}${fullPath()}`;
    redirectForDownload(url);
    props.onRequestSubmit();
  }

  return (
    <Modal
      onRequestClose={props.onRequestClose}
      onRequestSubmit={handleSubmit}
      title="Specify your tenant"
      buttons={[{text: 'Launch', submit: true, style: ButtonStyle.SECONDARY}]}
    >
      <Row>
        <Col md={12}>
          <p>
            For more details regarding your tenant, check out our{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://docs.benchling.com/docs/getting-started-1#the-api-and-benchling-domains"
            >
              documentation.
            </a>{' '}
            (Requires a valid Benchling login with API credentials)
          </p>
          <p>
            Note: We recommend bookmarking the page once you’ve been redirected. It will always have the most
            up to date information for your tenant.
          </p>
          <FormGroup>
            <TextField
              label="Tenant Subdomain"
              value={tenantSubdomain}
              onChange={(e: InputChangeEvent) => {
                setTenantSubdomain(e.target.value);
              }}
              placeholder="your-domain (example.benchling.com)"
            />
          </FormGroup>
        </Col>
      </Row>
    </Modal>
  );
}
